import * as React from 'react';

import {Carousel} from 'antd';

import RichText from '@app/components/UI/RichText/RichText';
import {appointmentInformation, sliderItems} from '@app/components/Pages/Services/Euthanasia/euthanasiaContent';

import '@app/scss/components/euthanasiaSlider.scss';

const arrowIcon = require('@app/images/arrow_circle.svg');

const EuthanasiaSlider = (props) => {
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const slider = React.useRef<any>();
	
	return (
		<div className="euthanasia-slider">
			<RichText
				title="Appointment information"
				text={appointmentInformation}
			/>
			<Carousel
				ref={slider}
				slidesToShow={1}
				afterChange={setCurrentIndex}
				dots={true}
				infinite
			>
				{
					sliderItems.map((item, index) => (
						<React.Fragment key={index}>
							<img src={item.src} alt={item.alt} style={item.style}/>
							<p className="euthanasia-slider-slide-caption">{item.text}</p>
						</React.Fragment>
					))
				}
			</Carousel>
			<div className="slider-tes-buttons">
				<img
					className="slider-tes-button slider-tes-button_left"
					src={arrowIcon}
					alt="Prev"
					onClick={() => slider.current!.prev()}
				/>
				<img
					className="slider-tes-button"
					src={arrowIcon}
					alt="Next"
					onClick={() => slider.current!.next()}
				/>
			</div>
		</div>			
	);
};

export default EuthanasiaSlider;